import { render, staticRenderFns } from "./WebhookList.vue?vue&type=template&id=4ba92f08&"
import script from "./WebhookList.vue?vue&type=script&lang=ts&"
export * from "./WebhookList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports